(function () {
'use strict';

angular.module('hyresgastApp').controller('SearchAgreementsCtrl', SearchAgreementsCtrl);

function SearchAgreementsCtrl($scope, $routeParams, $location,
  SubPage, Auth) {
  var vm = this;
  vm.Auth = Auth;

  let setupTabs = () => {
    vm.tablist = [
      { title: 'Överenskommelse', path: '/search/agreements?view=agreements' },
      { title: 'Avtal', path: '/search/agreements?view=free' },
    ];
  };

  function getCurrentSubpage() {
    var defaultSubPage = 'agreements';
    // create a validation list against manually change of URL '?view=' parameter
    var whiteList = ['agreements', 'free'];
    vm.currentSubpage = SubPage.set($routeParams.view, whiteList, defaultSubPage);
  }

  getCurrentSubpage();
  setupTabs();

  $scope.$on('$routeUpdate', function() {
    if (!$location.search().order) {
      getCurrentSubpage();
    }
  });
}

})();